var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Wave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.87 48.38a14.84 14.84 0 00-.09-19l3-2.67a18.82 18.82 0 01.09 24.3l-3-2.63zm16.94-9.43a28.19 28.19 0 00-7-18.57l-3 2.67a24.25 24.25 0 01.07 31.72l3 2.68a28.19 28.19 0 006.93-18.51v.01zm9.07 0a37.23 37.23 0 00-9.3-24.64l-3 2.67a33.29 33.29 0 01.07 43.85l3 2.68a37.23 37.23 0 009.23-24.57v.01z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Wave.205ddbbd.svg";
export { SvgG1Wave as ReactComponent };